import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToEstateAgentsForm } from '@shared/components/forms/estate-agents'
import { FullLogo } from '@shared/components/logo'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

export const View = () => {
	return (
		<Section fullWidth className={styles.wrap}>
			<div className={styles.content}>
				<div className={styles.texts}>
					<h4 className={styles.title}>
						Целевая ипотека от Credit.Club в&nbsp;партнёрстве с банками
					</h4>
					<FullLogo className={styles.logo} />
				</div>
				<Button className={styles.button} onClick={scrollToEstateAgentsForm}>
					Узнать подробней
				</Button>
			</div>
		</Section>
	)
}
